import React from "react";

function MediaThumb({ src, onClick }) {
    const isVideo = (url = "") => /\.(mp4|webm|ogg|mov|m4v)(\?|#|$)/i.test(url);

    const commonStyle = {
        width: "32%",
        height: 150,
        margin: "5px",
        borderRadius: 3,
        cursor: "pointer",
        objectFit: "cover",
        display: "block",
    };

    return isVideo(src) ? (
        <video
            src={src}
            muted
            playsInline
            preload="metadata"
            style={commonStyle}
            onClick={onClick}
        />
    ) : (
        <img src={src} alt="" style={commonStyle} onClick={onClick} />
    );
}

export default MediaThumb;
